import { SportTypes } from 'WorkoutPage/constants/WorkoutConstants';
import {
    FETCH_EXERCISE_TYPES_FETCHING,
    FETCH_EXERCISE_TYPES_SUCCESS,
    FETCH_EXERCISE_TYPES_FAIL
} from 'actions/ActionTypes';

import { flattenExerciseTypes } from 'utils/ExerciseTypesUtil';

const INITIAL_STATE = {
    exerciseTypes: {},
    flattenedExerciseTypes: {},
    exerciseTypesFetching: false,
    exerciseTypesSucces: false,
    exerciseTypesFail: false
};

const exerciseTypesFetching = (state) => ({
    ...state,
    exerciseTypesFetching: true
});

const exerciseTypesFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        exerciseTypes: isSuccess ? action.exerciseTypesData : {},
        flattenedExerciseTypes: isSuccess
            ? {
                  ...state.flattenedExerciseTypes,
                  [action.sportType]: flattenExerciseTypes(action.exerciseTypesData, action.fullLocale)
              }
            : state.flattenedExerciseTypes,
        exerciseTypesFetching: false,
        exerciseTypesSucces: isSuccess,
        exerciseTypesFail: !isSuccess
    };
};

export const isExerciseTypesFetching = (state) => {
    return state.exerciseTypes.exerciseTypesFetching;
};

export const isExerciseTypesFetchSuccess = (state) => {
    return state.exerciseTypes.exerciseTypesSucces;
};

export const isExerciseTypesFetchFail = (state) => {
    return state.exerciseTypes.exerciseTypesFail;
};

/**
 * Get the exercise types from Exercises.json that are without isBodyWeight
 * @param {object} state
 * @returns {{
 *   categoryKey: string;
 *   exerciseKey: string;
 *   exerciseName: string;
 *   primaryMuscles: string[];
 *   secondaryMuscles: string[];
 *   counterpart?: string | null;
 *   isBodyWeight?: null;
 * }[]} weightExerciseTypes
 */
export const getWeightExerciseTypes = (state) => {
    return (
        state.exerciseTypes.flattenedExerciseTypes[SportTypes.Strength_Training]?.filter(
            (exercise) => !exercise.isBodyWeight
        ) ?? []
    );
};

/**
 * Get the flattened exercise types array, which is from either Exercises.json, Pilates.json or Yoga.json,
 * please refer to exerciseTypesSagas.js - fetchExerciseTypes for details
 * @param {object} state
 * @param {string} sportType
 * @returns {{
 *   categoryKey: string;
 *   exerciseKey: string;
 *   exerciseName: string;
 *   primaryMuscles: string[];
 *   secondaryMuscles: string[];
 *   isBodyWeight?: boolean | null;
 *   counterpart?: string | null;
 * }[]} flattenedExerciseTypes
 */
export const getFlattenedExerciseTypes = (state, sportType = SportTypes.Strength_Training) => {
    return state.exerciseTypes.flattenedExerciseTypes[sportType] ?? [];
};

/**
 * Get list of exercise types that are already fetched
 * @param {object} state
 * @returns {string[]}
 */
export const getFetchedExerciseTypesList = (state) => {
    return Object.keys(state.exerciseTypes.flattenedExerciseTypes ?? {});
};

const handlers = {
    [FETCH_EXERCISE_TYPES_FETCHING]: exerciseTypesFetching,
    [FETCH_EXERCISE_TYPES_SUCCESS]: exerciseTypesFetchFinished(true),
    [FETCH_EXERCISE_TYPES_FAIL]: exerciseTypesFetchFinished(false)
};

export default function exerciseTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
